import { useEffect, useState } from 'react';

import ChatbotPopup from './ChatbotPopup';
import ChatbotButton from './ChatbotButton';
import { ChatbotContextProvider } from 'src/contexts/ChatbotContext';

export const Chatbot = () => {
  const [showButton, setShowButton] = useState<boolean>(false);
  const [isChatOpen, setIsChatOpen] = useState<boolean>(false);

  useEffect(() => {
    setTimeout(() => {
      setShowButton(true);
    }, 3000);
  }, []);

  const hideChatBot = import.meta.env.VITE_CHATBOT_ENABLED.toLowerCase() !== 'true';
  if (hideChatBot) {
    return null;
  }
  if (isChatOpen) {
    return (
      <ChatbotContextProvider>
        <ChatbotPopup isChatOpen={isChatOpen} setIsChatOpen={setIsChatOpen} />
      </ChatbotContextProvider>
    );
  }
  return (
    <>
      <ChatbotButton
        isChatOpen={isChatOpen}
        setIsChatOpen={setIsChatOpen}
        showButton={showButton}
        setShowButton={setShowButton}
      ></ChatbotButton>
    </>
  );
};

export default Chatbot;
